import { ActualsDetails } from "components/actuals/SharedFiles/definition";
import dayjs, { Dayjs } from "dayjs";
export const SUPPORT_EMAIL = "reconsupport@versantmedia.com";

export const sideOptions: string[] = ["X", "Y"];
export const bothSidesOption = "X and Y";
export const bulkEditSideOptions: string[] = [...sideOptions, bothSidesOption];
export const airedOptions: string[] = ["YES", "NO"];
export const actualsEditableFields: Array<keyof ActualsDetails> = ["matId", "billingRef", "channel", "ticket", "aired"];
export const spotList = ["Asset", "Commercial", "Spot", "SPOT"];
export const graphicList = ["Graphic", "Junction"];
export const prodPlacementList = ["productPlacements", "Product Placement", "Product Placements"];
export const opsEventsList = ["BLK", "BLKONE", "BLKH"];
export const programList = ["Live", "LiveRecord", "Programme", "SEG", "Segment", "Segments"];
export const optionalFields = ["eventCode", "eventTitle", "prodTitle", "podPosition", "ticket"];
export const errorMsg = (field: string) => `Error in submitting ${field}`;
export const updateMsg = (field: string) => `${field} updated successfully `;
export const createSuccessMsg = (field: string) => `${field} created successfully `;
export const actualsLabel = "Actuals";
export const hrstimeRegex = /^([01]?[0-9]|2[0-3]):([0-5]?[0-9]):([0-5]?[0-9])$/;
export const dateRegex = /^(0[1-9]|1[0-2])\/([0-2][0-9]|3[01])\/\d{4}$/;
export const durationRegex = /^([0-5]?[0-9]):([0-5]?[0-9])$/;
export const invalidTimeMsg = "Invalid time format. Must be hh:mm:ss.";
export const invalidDateMsg = "Invalid date format. Must be mm/dd/yyyy.";
export const invalidDurationMsg = "Invalid duration format. Must be mm:ss.";

export const actualsTableHeader = {
  hitTime: "Hit Time",
  duration: "Duration",
  podPosition: "POD POS",
  eventCode: "Event Code",
  materialType: "Mat Type",
  matId: "Mat ID",
  aired: "Aired",
  side: "SIDE",
  eventTitle: "Event Title",
  prodTitle: "Product Title",
  billingRef: "Billing Ref Code",
  ticket: "Ticket",
  feedPurpose: "Feed Purpose",
  feedNo: "FD",
  channel: "CH",
  updatedBy: "Last Updated By",
  updatedOn: "Last Updated On",
};

export const materialTypes: string[] = ["Spot", "Segment", "Graphics", "Product Placements", "Operational Events"];

export const labels = {
  addShow: "Add",
  editShow: "Edit ",
  spot: "Spot",
  segment: "Segment",
  primary: "Primary",
  nonPrimary: "NonPrimary",
  fromError: "From date cannot be later than To date",
  toError: "To date cannot not be less than From date",
  recon: "recon",
  network: "network",
  bdate: "bdate",
  graphic: "graphic",
  opsEvents: "opsEvents",
};

export const Timezones = [
  { name: "America/New_York", value: "ET" },
  { name: "America/Chicago", value: "CT" },
  { name: "America/Denver", value: "MT" },
  { name: "America/Los_Angeles", value: "PT" },
  { name: "GMT", value: "GMT" },
];

export const calculatedStatusList = {
  airedWithoutDisc: "Aired Without Discrepancy",
  airedWithContentDisc: "Aired with Content Discrepancy",
  airedWithDurationDisc: "Aired with Duration Discrepancy",
  joinedInProg: "Joined In Progress",
  didNotAir: "Did not air",
};

export const checkboxList = [
  { name: "Spot", key: "spot" },
  { name: "Segments", key: "program" },
  { name: "Graphics", key: "graphic" },
  { name: "Product Placements", key: "prodPlacement" },
  { name: "Operational Events", key: "opsEvents" },
];

export const displayMaterialCheckboxList = [
  { name: "Spot", key: "spot" },
  { name: "Segment", key: "program" },
  { name: "Graphic", key: "graphic" },
  { name: "Product Placement", key: "prodPlacement" },
  { name: "Operational Event", key: "opsEvents" },
];

export const listMapping: { [key: string]: string[] } = {
  spot: spotList,
  program: programList,
  graphic: graphicList,
  prodPlacement: prodPlacementList,
  opsEvents: opsEventsList,
};

export const fieldNames: any = {
  podPosition: "podPosition",
  eventCode: "eventCode",
  matId: "matId",
  materialType: "materialType",
  aired: "aired",
  eventTitle: "eventTitle",
  prodTitle: "prodTitle",
  billingRef: "billingRef",
  ticket: "ticket",
  feedPurpose: "feedPurpose",
  side: "side",
  feedNo: "feedNo",
  channel: "channel",
};

export const DATE_TIME_FORMAT_GMT = "YYYY-MM-DDTHH:mm:ss.SSS[Z]";
export const DATE_TIME_DISPLAY_FORMAT = "YYYY-MM-DD HH:mm:ss";
export const DATE_TIME_FORMAT_GMT_WITHOUT_MS = "YYYY-MM-DDTHH:mm:ss[Z]";
export const DATE_TIME_UTC_FORMAT = "MM/DD/YYYY hh:mm:ss A";
export const DATE_TIME_UTC_FORMAT_24HR = "MM/DD/YYYY HH:mm:ss";
export const ET_TIME_ZONE = "America/New_York";
export const ACTUALS_DISPLAY_TIME_ZONE = ET_TIME_ZONE;
export const ACTUALS_DISPLAY_TIME_ZONE_LABEL = "ET";

export const airedValues = ["YES", "NO"];

export const productPlacement = "Product Placement";

export const hitTime = "Hit Time";
export const hitDate = "Hit Date";
export const yesterday = dayjs().subtract(1, "day");
export const DATADOG_RUM_SITE = "datadoghq.com";
export const DATADOG_RUM_SERVICE = "Recon-UI";
